import { Action, createReducer, on } from '@ngrx/store';
import { SavedFilter } from 'src/app/models/saved-filter';

import { PageNamesEnum } from '../../../models/page-names';
import { resetSavedFilter, savedFilterUpdated } from '../actions/saved-filter.actions';

export interface SavedFilterState extends SavedFilter {
  selected: boolean;
}

const initialState: SavedFilterState[] = Object.values(PageNamesEnum).map((pageName) => ({
  id: null,
  name: null,
  page_name: pageName,
  filter_data: {},
  selected: false,
}));

const reducer = createReducer(
  initialState,
  on(savedFilterUpdated, (state: SavedFilterState[], { payload }) => [
    ...state.map((savedFilterState) => (savedFilterState.page_name === payload.page_name ? payload : savedFilterState)),
  ]),
  on(resetSavedFilter, () => initialState),
);

export function savedFilterReducer(state: SavedFilterState[], action: Action): SavedFilterState[] {
  return reducer(state, action);
}
